<template>
  <div class="animated fadeIn">
    <div id="companylocations">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>
          companylocations
          <!--<records-count :total="pageInfo.totalItems" />-->
          <b-button
            @click="add()"
            size="sm"
            title="Add"
            style="float: right;margin-bottom: 5px;">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </b-button>
        </div>
        <div class="card-body">
          <!-- <pre>{{ pageInfo | json }}</pre> -->

          <Grid id="companylocationsGrid"
          :style="{height: '480px'}"
          :data-items="companylocations"
          :columns="fields"
          :pageable="true"
          :take="take"
          :page-size="pageInfo.pageSize"
          :skip="skip"
          :resizable="true"
          :reorderable="true"
          :sortable="true"
          :sort= "sort2"
          :row-height="30"
          :total="pageInfo.totalItems"
          @pagechange="pageChangeHandler"
          @columnreorder="columnReorder"
          @sortchange="sortChangeHandler"
          @rowclick="onRowClick"
          >
          <template v-slot:myTemplate="{props}">
            <td>{{ props.dataItem.rfqModified | moment("L") }}</td>
          </template>
          <template v-slot:myTemplate2="{props}">
            <td>{{ props.dataItem.needsBy | moment("L") }}</td>
          </template>
          </Grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { debounce } from 'lodash';
import gridFields from './fields';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
  data() {
    return {
      pageNumber: 1,
      skip: 0,
      take: 10,
      sort2: [],
      fields: gridFields
    };
  },
  computed: {
    ...mapState('companylocations', [
      'companylocations',
      'pageInfo',
      'sort',
      'sortOrder',
      'searchQuery'
    ])
  },
  methods: {
    ...mapActions('companylocations', [
      'getAll',
      'sortGrid',
      'getPage',
      'remove',
      'search'
    ]),
    sortChangeHandler: function(e) {
      console.log(e);
      if (e.sort.length > 0) {
        this.sortGrid(e.sort[0].field, e.sort[0].dir == 'asc' ? 'ASC' : 'DESC')
      }
      else {
        this.sortGrid('id');
      }
      console.log(this.sortBy, this.sortOrder);
      this.sort2 = e.sort;
    },
    columnReorder: function(options) {
      this.fields2 = options.columns;
    },
    pageFunction: function(e) {
      console.log(e);
    },
    onSearch: debounce(function(e) {
      this.search(e);
    }, SEARCH_DEBOUNCE_TIME),
    onRowClick: function(event){
      this.edit(event.dataItem);
    },
    edit(item) {
      this.$router.push({ name: 'companylocationEdit', params: { id: item.id } });
    },
    add() {
      this.$router.push({ name: 'companylocationAdd' });
    },
    getNestedValue: function(field, dataItem) {
      console.log(field, dataItem)
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
      let pageNumber = Math.floor(event.page.skip / event.page.take) + 1;

      if (pageNumber != this.pageNumber) {
        this.pageNumber = Math.floor(event.page.skip / event.page.take) + 1;
        this.getAll(this.pageNumber);
      }
    },
  },
  watch: {
    pageInfo: function(newPageInfo) {
      this.pageNumber = newPageInfo.pageNumber;
    }
  },
  created() {
    this.getAll();
  }
};
</script>
<style>
.b-pagination {
  justify-content: center;
}

#KendoGrid .k-virtual-scrollable-wrap table
{
    min-width: 800px;
}
</style>
